import {
    DriversMenuRow,
    DriversRow,
    ErrorResponse,
    SelectDriversMenuRequest,
} from "../../api";
import { driverMenuSlice } from "../../features/DriversListMenu/store";
import { commonSlice, store } from "../../store";
import { api } from "../common/make_api";
import {
    ActionType,
    ResourceType,
    StatusType,
    sendLog,
} from "../common/send_log";
import { Logout } from "../login/login";

export const selectPlanType = async (
    plan_type: string | null
): Promise<void> => {
    store.dispatch(driverMenuSlice.actions.selectedPlanType(plan_type));
};

export const selectDriver = async (
    driver: DriversRow | null
): Promise<void> => {
    store.dispatch(driverMenuSlice.actions.setSelectedDriver(driver));
};

export const selectOfficeId = async (
    office_id: number | null
): Promise<void> => {
    store.dispatch(driverMenuSlice.actions.setSelectedOfficeId(office_id));
};

export const initDriverList = async (officeId: number) => {
    store.dispatch(driverMenuSlice.actions.setCondition([officeId, "all"]));
    const drivers = await getDriverList();
    if (drivers) {
        store.dispatch(driverMenuSlice.actions.setResults(drivers));
    }
};

export const updateDriverList = async () => {
    store.dispatch(commonSlice.actions.startLoading());
    store.dispatch(driverMenuSlice.actions.setResults(null));

    try {
        const drivers = await getDriverList();
        if (drivers) {
            store.dispatch(driverMenuSlice.actions.setResults(drivers));
        }
    } catch (err) {
        console.log("Got this error from shift_reports:", err);
        if (err["status"] == 401) {
            console.log("Session has expired");
            Logout();
            return;
        }

        if (err.message) {
            store.dispatch(
                commonSlice.actions.setErrorMessage([err.message as string])
            );
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return null;
        }
        if (err.status && err.status == 500) {
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return null;
        }
        const res = (await (err as Response).json()) as ErrorResponse;
        store.dispatch(commonSlice.actions.setErrorMessage([res.message!]));
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
};

const getDriverList = async (): Promise<DriversMenuRow[] | null> => {
    const state = store.getState();
    let office_ids = state.common.officeIds;
    const driver = state.drivermenu.selectedDriver;
    const plan_type = state.drivermenu.selectedPlanType;
    const selected_office =
        state.drivermenu.selectedOfficeId == -1
            ? null
            : state.drivermenu.selectedOfficeId;

    if (!selected_office) {
        console.log("Passed empty office id:", selected_office);
        return null;
    }

    if (!office_ids) {
        console.log("Passed empty office ids:", office_ids);
        office_ids = [selected_office];
    }

    if (plan_type == null) {
        console.log("PlanType not selected:", plan_type);
        return null;
    }

    const req: SelectDriversMenuRequest = {
        officeIds: office_ids,
        planType: plan_type,
        officeId: selected_office,
    };

    if (driver && driver.driverId) {
        req.driverId = driver.driverId;
    }

    console.debug("DriversMenu request", req);
    const res = await api.getCommonAPI().selectDriversMenu(req);
    console.debug("DriversMenu response", res);

    // office_id will be -1 even if selected, b/c
    // driver_list_menu uses office_id from its own slice, not commonSlice office_id
    sendLog(
        ResourceType.DRIVER_LIST_MENU,
        StatusType.GET_RESOURCE,
        ActionType.SELECT_DRIVER_LIST,
        {
            action_type: ActionType.SELECT_DRIVER_LIST.toString(),
            driver_menu_selected_plan: plan_type,
            driver_menu_driver_id: driver?.driverId ?? null,
            driver_menu_office_id: selected_office,
        }
    );

    return res.drivers ? res.drivers : [];
};
